<template>
  <FormBox>
    <!-- 单行输入框 -->
    <el-input
      v-if="type === 'input'"
      v-model="inputValue"
      class="input"
      :placeholder="placeholder"
      clearable
      :disabled="disabled"
      @change="onChange"
    />
    <!-- 多行输入框 -->
    <el-input
      v-if="type === 'textarea'"
      v-model="inputValue"
      class="input-textarea"
      :placeholder="placeholder"
      type="textarea"
      :rows="3"
      show-word-limit
      clearable
      :disabled="disabled"
      @change="onChange"
    />
    <span v-if="unit" class="unit">{{unit}}</span>
  </FormBox>
</template>

<script>
import FormBox from './FormBox'

export default {
  model: {
    prop: 'value',
    event: 'onChange'
  },
  components: {
    FormBox
  },
  props: {
    type: {
      type: String,
      default: 'input',
      validator: (val) => ['input', 'textarea'].indexOf(val) > -1
    },
    placeholder: {
      type: String,
      default: '请输入'
    },
    unit: String,
    disabled: [Function, Boolean]
  },
  data () {
    return {
      inputValue: ''
    }
  },
  mounted () {
    this.inputValue = this.$attrs.value
  },
  watch: {
    '$attrs.value' (newVal) {
      this.inputValue = newVal
    }
  },
  methods: {
    onChange () {
      this.$emit('onChange', this.inputValue)
    }
  }
}
</script>

<style lang="scss" scoped>
.input {
  width: 260px;
}
.input-textarea {
  width: 350px;
}
/deep/ .el-textarea__inner {
  font-family: PingFangSC-Regular, PingFang SC;
  &::placeholder {
    font-family: PingFangSC-Regular, PingFang SC;
  }
}
.unit {
  white-space: nowrap;
  font-size: 14px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  margin-left: 10px;
}
</style>
